export default {
  BASE_URL: 'bid/',
  api: [
    {
      name: 'detail',
      method: 'GET',
      desc: '获取标书详情',
      path: 'detail',
      params: {
        id: ''
      }
    },
    {
      name: 'searchbid',
      method: 'GET',
      desc: '标书查询-全部',
      path: 'searchbid'
    },
    {
      name: 'tenderList',
      method: 'GET',
      desc: '标书查询，除全部以外的所有查询接口',
      path: 'list'
    },
    {
      name: 'tenderInfo',
      method: 'GET',
      desc: '投标详情',
      path: 'tenderInfo'
    },
    {
      name: 'getBillStatus',
      method: 'GET',
      desc: '获得标书查询的状态',
      path: 'getBillStatus'
    },
    {
      name: 'searchbidExcel',
      method: 'GET',
      desc: '全部、撤标、流标导出excel',
      path: 'searchbidExcel'
    },
    {
      name: 'listExcel',
      method: 'GET',
      desc: '除全部、撤标、流标导出excel',
      path: 'listExcel'
    },
    {
      name: 'getModifyHistory',
      method: 'GET',
      desc: '查询标书变更记录',
      path: 'modify/history'
    },
    {
      name: 'getDownloadInfo',
      method: 'GET',
      desc: '查看供应商下载详情',
      path: '/getDownloadInfo'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/tender/bid.js